export type BackfillScope = 'customers' | 'orders';

export const SCOPES = {
  customers: 'customers',
  orders: 'orders',
};
